/* em-wm-light.js – watermark DearEm trên ảnh preview mờ hơn một chút (mọi product template).
   - Khung thiết kế: lớp .dmc-wm opacity .1 → .07.
   - Ảnh xem lại / preview canvas: thay D.renderDesignImage = renderRaw + watermark × 0.7
     (vẽ watermark gốc lên canvas trong suốt rồi đè lên ảnh với globalAlpha 0.7).
   v1 – 27/10/2026 (Claude) */
(function () {
  if (window.__emWmLight) return;
  window.__emWmLight = 1;
  var K = 0.7, OPACITY = 0.07;

  var st = document.createElement('style');
  st.textContent = 'html body .dmc-canvas>div.dmc-wm{opacity:' + OPACITY + '!important}' +
    'html body .dmp-wm,html body [class*="-wm"][class*="dmp"]{opacity:' + OPACITY + '!important}';
  document.head.appendChild(st);

  function light(D, cv) {
    if (!cv || !cv.getContext || !D.__emWmOrig) return Promise.resolve(cv);
    var w = document.createElement('canvas');
    w.width = cv.width; w.height = cv.height;
    return D.__emWmOrig(w).then(function () {
      var x = cv.getContext('2d');
      x.save(); x.globalAlpha = K; x.drawImage(w, 0, 0); x.restore();
      return cv;
    }, function () { return cv; });
  }

  function patch() {
    var D = window.DearEmCustomizer;
    if (!D || !D.__wm || !D.watermarkCanvas || !D.renderRaw || D.__emWmL) return !!(D && D.__emWmL);
    D.__emWmL = 1;
    D.__emWmOrig = D.watermarkCanvas;
    D.watermarkCanvas = function (cv) { return light(D, cv); };
    var g = function () {
      return D.renderRaw.apply(this, arguments).then(function (cv) { return light(D, cv); });
    };
    g.__emQ = 1; // renderRaw đã gồm lớp quote (em-quote-layer) → không bọc lần nữa
    D.renderDesignImage = g;
    return true;
  }
  if (!patch()) {
    var n = 0, iv = setInterval(function () { if (patch() || ++n > 100) clearInterval(iv); }, 200);
  }
})();
